export const CATEGORY_ID_ROUTE_PARAM = 'categoryId' as const
